import React from "react";
import {
  MdTextFormat,
  MdArrowDropDownCircle,
  MdPhone,
  MdInsertDriveFile,
  MdCheckBox,
  MdRadioButtonChecked,
  MdEmail,
  MdVisibilityOff,
} from "react-icons/md";
import { GoCalendar } from "react-icons/go";
import { GiChecklist } from "react-icons/gi";
import { AiFillFileAdd } from "react-icons/ai";
import FormatListNumberedIcon from "@material-ui/icons/FormatListNumbered";
import {
  FaCode,
  FaExternalLinkAlt,
  FaDollarSign,
  FaBarcode,
} from "react-icons/fa";
import COLORS from "scss/colors.module.scss";
import { Icon } from "@material-ui/core";
import { isElement } from "react-is";
import styled from "styled-components";

export function getHeaderIcon(columnTypeId, color = COLORS.TEXT_COLOR) {
  if (isElement(columnTypeId)) {
    return <columnTypeId />;
  }

  switch (columnTypeId) {
    case "1":
      return <MdTextFormat style={styles.icon} size={18} color={color} />;
    case "3":
      return (
        <MdArrowDropDownCircle style={styles.icon} size={18} color={color} />
      );
    case "4":
      return <GoCalendar style={styles.icon} size={18} color={color} />;
    case "5":
      return <StyledNumberIcon />;
    case "6":
      return <AiFillFileAdd style={styles.icon} size={18} color={color} />;
    case "7":
    case "19":
      return <FaCode style={styles.icon} size={18} color={color} />;
    case "8":
      return <MdTextFormat style={styles.icon} size={18} color={color} />;
    case "9":
      return <MdInsertDriveFile style={styles.icon} size={18} color={color} />;
    case "10":
      return <FaExternalLinkAlt style={styles.icon} size={18} color={color} />;
    case "11":
      return <GiChecklist style={styles.icon} size={18} color={color} />;
    case "12":
      return (
        <MdRadioButtonChecked style={styles.icon} size={18} color={color} />
      );
    case "13":
      return <MdCheckBox style={styles.icon} size={18} color={color} />;
    case "14":
      return <MdEmail style={styles.icon} size={18} color={color} />;
    case "15":
      return <MdVisibilityOff style={styles.icon} size={18} color={color} />;
    case "16":
      return <GoCalendar style={styles.icon} size={18} color={color} />;
    case "17":
      return <FaDollarSign style={styles.icon} size={18} color={color} />;
    case "18":
      return <FaBarcode style={styles.icon} size={18} color={color} />;
    case "20":
      return <MdPhone style={styles.icon} size={18} color={color} />;
    case 16:
      return <GoCalendar style={styles.icon} size={18} color={color} />;
    case "createdBy":
      return <GoCalendar style={styles.icon} size={18} color={color} />;
    default:
      return <Icon className={columnTypeId} />;
  }
}

const styles = {
  icon: {
    // flex: 1,
  },
};
const StyledNumberIcon = styled(FormatListNumberedIcon)`
  color: #212121 !important;
  cursor: default !important;
  font-size: 18px;
`;